import {ResourceParams} from "../resources";

export type DatabaseResourceType =
  'products' |
  'yandex-data' |
  'wildberries-orders' |
  'ozon-analytics' |
  'google-profits' |
  'social-media-metrics' |
  'customers' |
  'day-profits' |
  'wildberries-advertisements' |
  'ozon-advertisements' |
  'ozon-utm' |
  'wildberries-utm' |
  'wildberries-campaigns' |
  'wildberries-campaign-statistics' |
  'wildberries-campaign-sales' |
  'wildberries-net-profit' |
  'wildberries-expenses' |
  'wildberries-campaign-management' |
  'profit-before-ads';

export const databaseResources: {
  [key in DatabaseResourceType]: ResourceParams
} = {
  'products': {
    key: 'products',
    name: 'Группы товаров',
    path: 'products',
  },
  'yandex-data': {
    key: 'yandex-data',
    name: 'Yandex Data',
    path: 'yandex-data',
  },
  'wildberries-orders': {
    key: 'wildberries-orders',
    name: 'Wildberries Orders',
    path: 'wildberries-orders',
  },
  'ozon-analytics': {
    key: 'ozon-analytics',
    name: 'Ozon Analytics',
    path: 'ozon-analytics',
  },
  'google-profits': {
    key: 'google-profits',
    name: 'Прибыль по артикулу',
    path: 'google-profits',
  },
  'social-media-metrics': {
    key: 'social-media-metrics',
    name: 'Парсер Социальных Сетей',
    path: 'social-media-metrics',
  },
  'customers': {
    key: 'customers',
    name: 'Покупатели',
    path: 'customers'
  },
  'day-profits': {
    key: 'day-profits',
    name: 'Прибыль по дням',
    path: 'day-profits'
  },
  'wildberries-advertisements': {
    key: 'wildberries-advertisements',
    name: 'Рекламные расходы WB (Финансовый отчет)',
    path: 'wildberries-advertisements'
  },
  'ozon-advertisements': {
    key: 'ozon-advertisements',
    name: 'Рекламные расходы Ozon',
    path: 'ozon-advertisements'
  },
  'ozon-utm': {
    key: 'ozon-utm',
    name: 'Ozon Utm',
    path: 'ozon-utm'
  },
  'wildberries-utm': {
    key: 'wildberries-utm',
    name: 'Wildberries Utm',
    path: 'wildberries-utm'
  },
  'wildberries-campaigns': {
    key: 'wildberries-campaigns',
    name: 'Рекламные кампании WB',
    path: 'wildberries-campaigns'
  },
  'wildberries-campaign-statistics': {
    key: 'wildberries-campaign-statistics',
    name: 'Статистика рекламных кампаний WB',
    path: 'wildberries-campaign-statistics'
  },
  'wildberries-campaign-sales': {
    key: 'wildberries-campaign-sales',
    name: 'Продажи рекламных кампаний WB',
    path: 'wildberries-campaign-sales'
  },
  'wildberries-net-profit': {
    key: 'wildberries-net-profit',
    name: 'Чистейшая прибыль WB',
    path: 'wildberries-net-profit'
  },
  'wildberries-expenses': {
    key: 'wildberries-expenses',
    name: 'Сравнение расходов WB',
    path: 'wildberries-expenses'
  },
  'wildberries-campaign-management': {
    key: 'wildberries-campaign-management',
    name: 'Распределение типов РК WB',
    path: 'wildberries-campaign-management'
  },
  'profit-before-ads': {
    key: 'profit-before-ads',
    name: 'Прибыль до вычета расходов на рекламу',
    path: 'profit-before-ads'
  }
};
